import { useEffect, useState } from 'react'
import { Text, XStack, YStack } from 'tamagui'

import { useApp } from '../../../i18n'
import { Button } from '../../../ui'
import type { PdfViewerProps } from './PdfViewer'

/**
 * Встроенный просмотр PDF (web): iframe на blob URL. Файл ЭДО приватный (GET /files/:id его не
 * отдаёт), поэтому байты тянет вызывающий через api.edoAttachment, а здесь они только показываются.
 * URL создаётся в эффекте и освобождается при закрытии, размонтировании и смене файла.
 */
export function PdfViewer({ blob, src, title, onClose }: PdfViewerProps) {
  const { t } = useApp()
  const [url, setUrl] = useState<string>()
  useEffect(() => {
    // Файл отдаёт публичная ссылка (страница подписания контрагента) — показываем её как есть,
    // создавать blob незачем.
    if (!blob) return setUrl(src)
    // Тип принудительно PDF: при другом Content-Type iframe скачал бы файл, а не показал.
    const u = URL.createObjectURL(blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' }))
    setUrl(u)
    return () => URL.revokeObjectURL(u)
  }, [blob, src])

  return (
    <YStack gap={6} borderWidth={1} borderColor="$borderSecondary" borderRadius={7} overflow="hidden">
      <XStack alignItems="center" gap={10} paddingHorizontal={10} paddingVertical={6} backgroundColor="$bgLayout">
        <Text flex={1} fontSize={12} fontWeight="600" color="$color" numberOfLines={1}>
          {title}
        </Text>
        <Button size="sm" onPress={onClose}>
          {t({ ru: 'Закрыть', en: 'Close', az: 'Bağla' })}
        </Button>
      </XStack>
      {url && <iframe src={url} title={title} style={{ border: 0, width: '100%', height: '70vh', minHeight: 420 }} />}
    </YStack>
  )
}
